import React, {Component} from 'react';

/*
* Component for wrapping form fields into block
* */
const DisableAutoFill = (props) => {
    return <input type="hidden" value="prayer" />;
};

export default DisableAutoFill;


// WEBPACK FOOTER //
// ./web/src/components/common/form/DisableAutoFill.jsx